/* eslint no-undef: 0 */
import React, { useContext, useState, createContext } from 'react';
import { createPortal } from 'react-dom';
import { useIsomorphicEffect, canUseDOM } from '../../utils';
const getBodyElement = () => {
  if (canUseDOM) {
    return document.body;
  }

  // ssr
  return null;
};
const createDivElement = () => {
  if (canUseDOM) {
    return document.createElement('div');
  }

  // ssr
  return null;
};
export const PortalContext = /*#__PURE__*/createContext(getBodyElement());
const Portal = _ref => {
  let {
    children
  } = _ref;
  // if it's a nested portal, context is the parent portal
  // otherwise it's document.body
  const context = useContext(PortalContext) || getBodyElement();
  const [hostNode] = useState(createDivElement()); // eslint-disable-line react/hook-use-state

  useIsomorphicEffect(() => {
    if (!hostNode || !context) {
      return undefined;
    }
    context.appendChild(hostNode);
    return () => {
      context.removeChild(hostNode);
    };
  }, [hostNode, context]);
  if (hostNode) {
    return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(PortalContext.Provider, {
      value: hostNode
    }, children), hostNode);
  }

  // ssr
  return null;
};
export default Portal;